// Add Class
export const AddClassBase = 'configuration/add-class'
export const addClassList = AddClassBase + '/list'
export const addClassStore = AddClassBase + '/store'
export const addClassShow = AddClassBase + '/show'
export const addClassUpdate = AddClassBase + '/update'
export const addClassStatus = AddClassBase + '/toggle-status'
export const addClassDestroy = AddClassBase + '/destroy'

// information management
export const committeDesigBase = 'configuration/add-class'
export const committeDesigListApi = committeDesigBase + '/list'
export const committeDesigStoreApi = committeDesigBase + '/store'
export const committeDesigShowApi = committeDesigBase + '/show'
export const committeDesigUpdateApi = committeDesigBase + '/update'
export const committeDesigStatusApi = committeDesigBase + '/toggle-status'
export const committeDesigDestroyApi = committeDesigBase + '/destroy'

// Institute Type (Dummy Routes for Testing Purpose)
export const instituteTypeListApi = 'configuration/institute-type/list'
export const instituteTypeListStoreApi = 'configuration/institute-type/store'
export const instituteTypeListUpdateApi = 'configuration/institute-type/update'
export const instituteTypeListToggleStatusApi = 'configuration/institute-type/toggle-status'

// Demo List | Test API (3 Records)
export const SeizerListBase = 'configuration/add-class'
export const seizerList = SeizerListBase + '/list'
export const seizerStore = SeizerListBase + '/store'
export const seizerShow = SeizerListBase + '/show'
export const seizerUpdate = SeizerListBase + '/update'
export const seizerStatus = SeizerListBase + '/toggle-status'
export const seizerDestroy = SeizerListBase + '/destroy'

// Institute Profile Management
export const instituteListApi = 'institute-management/institution-profile-management/list'
export const instituteStoreApi = 'institute-management/institution-profile-management/store'
export const instituteUpdateApi = 'institute-management/institution-profile-management/update'
export const instituteToggleStatusApi = 'institute-management/institution-profile-management/toggle-status'

// Food Management
export const foodItemListApi = 'institute-management/food-management/list'
export const foodItemStoreApi = 'institute-management/food-management/store'
export const foodItemUpdateApi = 'institute-management/food-management/update'
export const foodItemToggleStatusApi = 'institute-management/food-management/toggle-status'

// Committee Management
export const committeemanagementListApi = 'institute-management/committee-management/list'
export const committeemanagementStoreApi = 'institute-management/committee-management/store'
export const committeemanagementUpdateApi = 'institute-management/committee-management/update'
export const committeemanagementToggleStatusApi = 'institute-management/committee-management/toggle-status'
// id card route
export const idCardList = 'institute-management/id-card/list'

// evaluation Setting
export const evaluationSetting = 'institute-management/evaluation-setting'
export const getResidentDetail = evaluationSetting + '/get-resident'
export const evaluationSettingList = evaluationSetting + '/list'
export const evaluationSettingStore = evaluationSetting + '/store'
export const evaluationApproveStore = evaluationSetting + '/approve-store'
export const evaluationRejectStore = evaluationSetting + '/reject-store'

// Grading management
export const gradingList = 'institute-management/grading-management/list'
export const gradingStore = 'institute-management/grading-management/store'

// Evaluation management
export const evaluationManagementList = 'institute-management/evaluation-management/list'
export const evaluationManagementUpdate = 'institute-management/evaluation-management/update'

// complain & feedback management route
export const complainFeedbkReportApi = 'institute-management/complain-feedback-management/report'
export const getResidentDetailApi = 'institute-management/complain-feedback-management/get-resident'
export const complainFeedbkListApi = 'institute-management/complain-feedback-management/list'
export const complainFeedbkStoreApi = 'institute-management/complain-feedback-management/store'

// instructor attendance route
export const instructorAttendanceListApi = 'institute-management/instructor-attendance-management/list'
export const instructorAttendanceStoreApi = 'institute-management/instructor-attendance-management/store'
export const instructorAttendanceUpdateApi = 'institute-management/instructor-attendance-management/update'
export const instructorInfoApi = 'institute-management/instructor-attendance-management/get-instructor-info'

// information dashboard route
export const informationDashboardApi = 'institute-management/information-dashboard/list'

// Certificate Management
export const certificateListApi = 'institute-management/institutional-certificate-management/list'
export const certificateApplyApi = 'institute-management/institutional-certificate-management/certificate-apply'
export const certificateDocUploadApi = 'institute-management/institutional-certificate-management/certificate-upload'
